/* Fleur de T'Anna: remove gift add-ons when their parent flower product is removed. */
(() => {
  if (window.__fleurGiftCartSyncInstalled) return;
  window.__fleurGiftCartSyncInstalled = true;

  const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const originalFetch = window.fetch.bind(window);
  let syncing = false;
  let reloadScheduled = false;

  async function reconcileGiftLines() {
    if (syncing) return;
    syncing = true;
    try {
      const response = await originalFetch(rootPath + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      if (!response.ok) return;
      const cart = await response.json();
      const parentGroups = new Set();
      cart.items.forEach((item) => {
        const props = item.properties || {};
        const group = props._GiftGroup;
        const isGift = String(props._GiftAddon || '').toLowerCase() === 'true';
        if (group && !isGift) parentGroups.add(String(group));
      });

      const orphanGifts = cart.items.filter((item) => {
        const props = item.properties || {};
        return String(props._GiftAddon || '').toLowerCase() === 'true' && props._GiftGroup && !parentGroups.has(String(props._GiftGroup));
      });
      if (!orphanGifts.length) return;

      for (const gift of orphanGifts) {
        await originalFetch(rootPath + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: gift.key, quantity: 0 })
        });
      }

      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      window.dispatchEvent(new CustomEvent('fleur:gift-cart-synced'));
      if (window.location.pathname.replace(/\/$/, '') === (rootPath + 'cart').replace(/\/$/, '') && !reloadScheduled) {
        reloadScheduled = true;
        window.location.reload();
      }
    } catch (error) {
      // Do not interrupt normal cart interactions if the network is temporarily unavailable.
    } finally {
      syncing = false;
    }
  }

  window.fetch = function(input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const isCartMutation = /\/cart\/(change|update|clear)(\.js)?(?:\?|$)/.test(url);
    const request = originalFetch(input, init);
    if (!isCartMutation || syncing) return request;
    return request.then((response) => {
      if (response.ok) window.setTimeout(reconcileGiftLines, 180);
      return response;
    });
  };

  document.addEventListener('cart:refresh', () => window.setTimeout(reconcileGiftLines, 180));
  document.addEventListener('cart:updated', () => window.setTimeout(reconcileGiftLines, 180));
  window.addEventListener('pageshow', () => window.setTimeout(reconcileGiftLines, 180));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => window.setTimeout(reconcileGiftLines, 180));
  else window.setTimeout(reconcileGiftLines, 180);
})();
